module.exports = __webpack_public_path__ + "static/media/microphone.ca145fad.png";